//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_TIPOS_DATO = "obteneTiposDato";

// mutation types
export const SET_TIPOS_DATO = "setTiposDato";
export const SET_TIPO_DATO = "setTipoDato";

const state = {
    tiposDato:[],
 }
const getters = {
    obtenerTiposDato(state) {
      return state.tiposDato;
    },
}

const actions = {
    async [OBTENER_TIPOS_DATO](context, estadoId) {
        
        let endpoint = `api/TipoDato`;
        if(estadoId!=0){
            endpoint = `api/TipoDato/Estado/${estadoId}`
        }
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_TIPOS_DATO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    
    }
}

const mutations = {
    [SET_TIPOS_DATO](state, data) {
        state.tiposDato = data;
    },

    [SET_TIPO_DATO](state, data) {
        state.tipoDato = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}